import React from 'react';

import Helmet from './Helmet';

const Title = 'getimg.ai Case Study | Canny';
const Description =
  'Read about how getimg.ai prioritizes feature development using Canny&apos;s feedback boards and user voting system.';
const Image = 'https://canny-assets.io/images/b98d1e4285edbd32ba5b44b0f3a0e3f9.png';

const GetimgAILandingHelmet = () => (
  <Helmet
    title={Title}
    meta={[
      { name: 'description', content: Description },

      { property: 'og:image', content: Image },
      { property: 'og:title', content: Title },
      { property: 'og:description', content: Description },
      { property: 'og:url', content: 'https://canny.io/case-studies/getimgai' },
      { property: 'og:type', content: 'website' },

      { name: 'twitter:card', content: 'summary_large_image' },
      { name: 'twitter:site', content: '@cannyHQ' },
      { name: 'twitter:title', content: Title },
      { name: 'twitter:description', content: Description },
      { name: 'twitter:image', content: Image },
    ]}
  />
);

export default GetimgAILandingHelmet;
